module.exports = __webpack_public_path__ + "img/QuickLinks.2f184709.svg";